// Path: ./src/app/components/ListCard/index.tsx
import React from "react";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import {
  RightSideBox,
  TopHeadRightBox,
  TitleHeadRightBox,
  SubTitleHeadRightBox,
  BottomRightBox,
  BottomTitleRightBox,
  BottomListWrapper,
  BottomListWithIcon,
  BottomList,
  UserWrapper,
  UserName,
} from "./styled";

interface Props {
  userName?: string;
  title: string;
  subTitle?: string;
  bottomTitle?: string;
  listItems?: {
    title: string;
    itemsList?: string[];
  }[];
}
export const ListCard = ({
  title,
  subTitle,
  bottomTitle,
  listItems,
  userName,
}: Props) => {
  return (
    <RightSideBox
      sx={{
        padding: {
          xs: "40px",
          sm: "80px",
        },
        paddingTop: {
          xs: "15px",
          sm: "15px",
        },
      }}
      data-testid="listcard-test-id"
    >
      {userName && (
        <UserWrapper>
          <ManageAccountsIcon style={{ fontSize: 40 }} />
          <UserName>{userName} </UserName>
        </UserWrapper>
      )}
      <TopHeadRightBox>
        <TitleHeadRightBox data-testid="this attribute is for test purpose only">
          {title}
        </TitleHeadRightBox>
        <SubTitleHeadRightBox>{subTitle}</SubTitleHeadRightBox>
      </TopHeadRightBox>
      <BottomRightBox>
        <BottomTitleRightBox>{bottomTitle}</BottomTitleRightBox>

        {listItems?.map((value) => {
          return (
            <BottomListWrapper key={value.title} data-testid="listcard-test-id">
              <BottomListWithIcon>
                {" "}
                <CheckBoxIcon
                  style={{
                    color: "#f58220",
                    marginRight: 5,
                  }}
                ></CheckBoxIcon>
                {value.title}
              </BottomListWithIcon>
              {value?.itemsList?.map((val) => {
                return (
                  <BottomList key={val} data-testid="listcard-test-id">
                    {val}
                  </BottomList>
                );
              })}
            </BottomListWrapper>
          );
        })}
      </BottomRightBox>
    </RightSideBox>
  );
};
